export default "__VITE_ASSET__Dor_1m0I__"